module.exports = __webpack_public_path__ + "img/spin-wheel-face-day-v2.e79da505.png";